// WhatsApp contact helper.
// The number and chat link are intentionally NOT stored as plain literals so
// spam bots that scrape page source / JS bundles for phone numbers and
// "wa.me/<digits>" links cannot harvest them. The link is assembled only at
// click time; the visible number is decoded at render time.

const _enc = 'OTIzMDA4MjAxMDc0';

const _decode = (s) => {
  try {
    return typeof atob !== 'undefined' ? atob(s) : Buffer.from(s, 'base64').toString('utf8');
  } catch {
    return '';
  }
};

const _num = () => _decode(_enc);
const _host = ['ht', 'tps://', 'wa', '.', 'me', '/'].join('');

export const DEFAULT_WA_MESSAGE =
  'Hello Kassam Trading Company, I would like to enquire about your products.';

// Pretty display like "+92 300 820 1074", assembled at runtime.
export const waDisplay = () => {
  const n = _num();
  if (n.length < 9) return '';
  return `+${n.slice(0, 2)} ${n.slice(2, 5)} ${n.slice(5, 8)} ${n.slice(8)}`;
};

// Opens WhatsApp chat with an optional pre-filled greeting. Link built on click.
export const openWhatsApp = (text = DEFAULT_WA_MESSAGE) => {
  const url = `${_host}${_num()}${text ? `?text=${encodeURIComponent(text)}` : ''}`;
  if (typeof window !== 'undefined') {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
};
